import { createStore } from 'vuex'
import groups from './modules/groups'
import auth from './modules/auth'
import questions from './modules/questions'
import pins from './modules/pins'
import evaluation from './modules/evaluation'
import session from './modules/session'
import schoolGrades from './modules/schoolGrades'
import schoolSubjects from './modules/schoolSubjects'
import reports from './modules/reports'

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    groups,
    auth,
    questions,
    pins,
    evaluation,
    session,
    schoolGrades,
    schoolSubjects,
    reports
  }
})